export default "__VITE_ASSET__DObyp9bz__"